export default __webpack_public_path__ + "static/media/h_1.74a0845a.jpg";